
export default {
    collection_add(state, payload) {
        if (state.collection) {
            state.collection.push(payload);
        }

        return state;
    },

    staged_add(state, payload) {
        if (state.staged) {
            state.staged.push(payload);
        }

        return state;
    }
}
